import { useTranslation } from "../../lib/i18n";

export const LoadingPage = () => {
  const { t } = useTranslation();

  return (
    <div className="relative h-full w-full">
      <div className="relative z-10 h-full w-full text-white flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-white mx-auto mb-4"></div>
          <p>{t('loading.text')}</p>
        </div>
      </div>
    </div>
  );
};
